import { useEffect } from 'react';

import { useAppSelector } from 'shared/lib';
import { sendSentryClientErrorOnce } from 'shared/lib/sendSentryClientError';

import { getUserScoreSelector, useGetScores } from 'entities/scoring';
import { useChannel } from 'entities/siteSettings/lib';
import { isLoggedSelector } from 'entities/user';

import { updateScoreValueSelector } from '../model/updateScoreValue.selector';

export const useUpdateScoreValue = () => {
  const { isNeedUpdateScore, queryData } = useAppSelector(updateScoreValueSelector);
  const userScore = useAppSelector(getUserScoreSelector);
  const isLogged = useAppSelector(isLoggedSelector);
  const channel = useChannel();

  const { isUninitialized, isFetching } = useGetScores(
    { ...queryData, channel },
    {
      skip: !isNeedUpdateScore || !isLogged,
    },
  );

  useEffect(() => {
    const shouldSkipMissingScoreLog =
      !isNeedUpdateScore || !isLogged || isUninitialized || isFetching || Boolean(userScore.source);

    if (shouldSkipMissingScoreLog) {
      return;
    }

    sendSentryClientErrorOnce(
      'useUpdateScoreValue.missedScoreInStore',
      'Score is missing in store after score request',
      {
        queryData,
        channel,
        scoreState: userScore,
      },
    );
  }, [channel, isFetching, isLogged, isNeedUpdateScore, isUninitialized, queryData, userScore]);
};
